export const UPDATE_GAMMA_STATE = "UPDATE_GAMMA_STATE";
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const UPDATE_LAST_MAP_COUNT = "UPDATE_LAST_MAP_COUNT";
